/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AWSRegionsEnum } from './aWSRegionsEnum';


export interface AWSLambdaInvokeSpec { 
    function_name: string;
    region_id?: AWSRegionsEnum;
}
export namespace AWSLambdaInvokeSpec {
}


